import React from "react"
import Icon from "./Icon"

const Values = ({ values }) => (
  <div className="values">
    <h2>Our values</h2>
    <div className="values-inner">
      {values.map(({ icon, title, description }) => (
        <div className="value" key={title}>
          <div className="value-inner">
            <Icon icon={icon} />
            <h5>{title}</h5>
            <p>{description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default Values
